import { Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Badge from "@material-ui/core/Badge";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { fade, makeStyles, useTheme } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DescriptionIcon from "@material-ui/icons/Description";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import GavelIcon from "@material-ui/icons/Gavel";
import HomeIcon from "@material-ui/icons/Home";
import MenuIcon from "@material-ui/icons/Menu";
import PeopleIcon from "@material-ui/icons/People";
import SettingsIcon from "@material-ui/icons/Settings";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Link, Route, Switch, withRouter } from "react-router-dom";
import firebase from "../../firebase";
import Permiso from "../../Permiso";
import App from "./App";
import Asignado from "./components/Asignado/Asignado";
import Catalogos from "./components/Catalogos/Catalogos";
import Configuracion from "./components/Configuracion/ConfigSwitch";
import Principal from "./components/Principal/Principal";
import Reportes from "./components/Reportes/Reportes";
import Solicitudes from "./components/Solicitudes/Solicitudes";
import Usuarios from "./components/Usuarios/Usuarios";
const firebaseD = require("firebase");
require("firebase/firestore");

const drawerWidth = 240;
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "15px"
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  hide: {
    display: "none"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(2),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(8),
      width: "auto"
    }
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200
      }
    }
  },
  logo: {
    width: "150px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "15px"
  }
}));

async function Autorizacion() {
  async function foo() {
    const k = new Permiso(); //Aqui hago instancia para llamar a la function que esta en Permiso.js
    const g = await k.Permiso(function(ans) {
      window.respuesta = ans;
      window.respuestaA = window.respuesta.checkedA;
      return ans;
    });
    return g;
  }

  await foo();
}
function Dashboard(props) {
  try {
    var Autorizacion2 = JSON.parse(localStorage.getItem("Permisos"));
    if (!window.respuesta) {
      window.respuesta = Autorizacion2;
    }
  } catch (err) {
    console.log(err);
  }

  Autorizacion();
  useEffect(() => {
    firebaseD
      .firestore()
      .collection("solicitudes")
      //.orderBy("timestamp", "desc")
      .onSnapshot(serverUpdate => {
        const notes = serverUpdate.docs.map(_doc => {
          const data = _doc.data();
          data["id"] = _doc.id;
          return data;
        });
        setCount(notes.length);
        firebaseD
          .firestore()
          .collection("datosConfiguracion")
          .doc("datos")
          .get()
          .then(async function(doc) {
            if (doc.exists) {
              setUrl(doc.data().img);
            } else {
              // doc.data() will be undefined in this case
            }
          })
          .catch(function(error) {
            console.log("Error getting document:", error);
          });
      });
  }, []);

  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(false);
  const [countSol, setCount] = useState(0);

  const [url, setUrl] = useState(
    "https://i.ibb.co/BGCyZq2/LOGO-BOCLAIMS-REGISTRADO.jpg"
  );

  if (!firebase.getCurrentUsername()) {
    // not logged in
    alert("Por Favor Inicio Sesion");
    props.history.replace("/login");
    return null;
  }

  const handleClose2 = () => {
    setOpen2(false);
  };

  function handleDrawerOpen() {
    setOpen(true);
  }

  function handleDrawerClose() {
    setOpen(false);
  }
  try {
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, open && classes.hide)}
            >
              <MenuIcon />
            </IconButton>
            <Typography className={classes.title} component="h1" variant="h5">
              Hola {firebase.getCurrentUsername()}
            </Typography>
          </Toolbar>
        </AppBar>
        {/*Side NavBar*/}
        <Drawer
          className={classes.drawer}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{
            paper: classes.drawerPaper
          }}
        >
          <div>
            <img className={classes.logo} src={url} alt="Boclaims logo" />
          </div>
          <div className={classes.drawerHeader}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>
            {window.respuestaA || Autorizacion2.checkedA ? (
              <>
                {" "}
                {/*AQUI EMPIEZA EL TERNARIO*/}
                <Link
                  to="/dashboard/principal"
                  style={{ textDecoration: "none", color: "#333333" }}
                >
                  <ListItem
                    button
                    key={0}
                    selected={
                      window.location.pathname === "/dashboard/principal"
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Principal" />
                  </ListItem>
                </Link>
                <Link
                  to="/dashboard/solicitudes"
                  style={{ textDecoration: "none", color: "#333333" }}
                >
                  <ListItem
                    button
                    key={1}
                    selected={
                      window.location.pathname === "/dashboard/solicitudes"
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <Badge badgeContent={countSol} color="primary">
                        <PeopleIcon />
                      </Badge>
                    </ListItemIcon>
                    <ListItemText primary={"Solicitudes"} />
                  </ListItem>
                </Link>
                <Link
                  to="/dashboard/casos"
                  style={{ textDecoration: "none", color: "#333333" }}
                >
                  <ListItem
                    button
                    key={2}
                    selected={
                      window.location.pathname === "/dashboard/casos"
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <GavelIcon />
                    </ListItemIcon>
                    <ListItemText primary="Casos" />
                  </ListItem>
                </Link>
                <Link
                  to="/dashboard/asignado"
                  style={{ textDecoration: "none", color: "#333333" }}
                >
                  <ListItem
                    button
                    key={3}
                    selected={
                      window.location.pathname === "/dashboard/asignado"
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <AssignmentIcon />
                    </ListItemIcon>
                    <ListItemText primary="Asignado" />
                  </ListItem>
                </Link>
                {window.respuesta.checkedG ? (
                  <>
                    <Link
                      to="/dashboard/reportes"
                      style={{ textDecoration: "none", color: "#333333" }}
                    >
                      <ListItem
                        button
                        key={4}
                        selected={
                          window.location.pathname === "/dashboard/reportes"
                            ? true
                            : false
                        }
                      >
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText primary="Reportes" />
                      </ListItem>
                    </Link>{" "}
                  </>
                ) : null}
                <Link
                  to="/dashboard/configuracion"
                  style={{ textDecoration: "none", color: "#333333" }}
                >
                  <ListItem
                    button
                    key={5}
                    selected={
                      window.location.pathname === "/dashboard/configuracion"
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <SettingsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Configuracion" />
                  </ListItem>
                </Link>
                <Link
                  to="/dashboard/catalogos"
                  style={{ textDecoration: "none", color: "#333333" }}
                >
                  <ListItem
                    button
                    key={6}
                    selected={
                      window.location.pathname === "/dashboard/catalogos"
                        ? true
                        : false
                    }
                  >
                    <ListItemIcon>
                      <FileCopyIcon />
                    </ListItemIcon>
                    <ListItemText primary="Catalogos" />
                  </ListItem>
                </Link>
                {window.respuesta.checkedI ? (
                  <>
                    <Link
                      to="/dashboard/usuarios"
                      style={{ textDecoration: "none", color: "#333333" }}
                    >
                      <ListItem
                        button
                        key={7}
                        selected={
                          window.location.pathname === "/dashboard/usuarios"
                            ? true
                            : false
                        }
                      >
                        <ListItemIcon>
                          <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Usuarios" />
                      </ListItem>
                    </Link>
                  </>
                ) : null}
                {/*<ListItem button key={8}>
            <ListItemIcon>
              <AssignmentIndIcon />
            </ListItemIcon>
            <ListItemText primary="Estructura Organizacional" />
            </ListItem>*/}
              </>
            ) : (
              <Link
                to="/dashboard/reportes"
                style={{ textDecoration: "none", color: "#333333" }}
              >
                <ListItem
                  button
                  key={4}
                  selected={
                    window.location.pathname === "/dashboard/reportes"
                      ? true
                      : false
                  }
                >
                  <ListItemIcon>
                    <GavelIcon />
                  </ListItemIcon>
                  <ListItemText primary="Mis Casos" />
                </ListItem>
              </Link>
            )}{" "}
            {/*AQUI TERMINA EL TERNARIO*/}
            <ListItem button key={9} onClick={() => setOpen2(true)}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="Salir" />
            </ListItem>
          </List>
        </Drawer>

        <Dialog
          open={open2}
          onClose={handleClose2}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"¿Desea cerrar sesion?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose2} color="primary">
              Cancelar
            </Button>
            <Button onClick={logout} color="primary" autoFocus>
              Salir
            </Button>
          </DialogActions>
        </Dialog>
        {/*App Content*/}
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: open
          })}
        >
          <div className={classes.drawerHeader} />
          {/* <App /> */}
          <Switch>
            {window.respuesta.checkedA ? (
              <>
                <Route path={`/dashboard/principal`} component={Principal} />
                <Route exact path={`/dashboard/casos`} component={App} />
                <Route path={`/dashboard/asignado`} component={Asignado} />
                <Route path={`/dashboard/catalogos`} component={Catalogos} />
                <Route
                  path={`/dashboard/configuracion`}
                  component={Configuracion}
                />
                {window.respuesta.checkedG ? (
                  <Route path={`/dashboard/reportes`} component={Reportes} />
                ) : null}

                <Route
                  path={`/dashboard/solicitudes`}
                  component={Solicitudes}
                />
                {window.respuesta.checkedI ? (
                  <Route path={`/dashboard/usuarios`} component={Usuarios} />
                ) : null}
              </>
            ) : (
              <Route path={`/dashboard/reportes`} component={Reportes} />
            )}
          </Switch>
        </main>
      </div>
    );
  } catch (ops) {
    console.log(ops);
    return null;
  }

  async function logout() {
    await firebase.logout();
    props.history.push("/");
  }

  //setNull = () =>{}
}

export default withRouter(Dashboard);
